
import classNames from 'classnames';
import { useGetCurrentUserProfile } from '../../../hooks/apolloHooks/useGetCurrentUserProfile';
import { useGetCustomer } from '../../../hooks/apolloHooks/useGetCustomer';
import { GET_CUSTOMER_TASKS_QUERY } from '../../../integrations/allkort/graphql/gql/CustomerQueries';
import { ContactDataResponse } from '../../../integrations/allkort/graphql/interface/Customer';
import { CustomerTasksResponse } from '../../../integrations/allkort/graphql/interface/CustomerTaskMutation';
import { EMAIL_TYPES, filterEmailsByType } from '../../../utils/filterEmailsByType';
import { InfoIconOutlined, ManageAccountIcon } from '../../svgs/ExpressonSVGs';
import Link from '../Link';
import RightsWrapper from '../RightsWrapper';
import Tooltip from '../Tooltip';


type ProfileDeleteAccountProps = {
    wrapperClasses?: string
    hasP: boolean
    hasK: boolean
    hasBankCards: boolean // TODO: do we need to check anything about the bankcards?
    hasAppAgreement: boolean
    isCompany: boolean
    customerContactData: ContactDataResponse
};

const ProfileDeleteAccount: React.FC<ProfileDeleteAccountProps> = ({ wrapperClasses, hasP, hasK, hasBankCards, hasAppAgreement, isCompany, customerContactData }) => {
    const { found: hasReceiptEmails } = filterEmailsByType(customerContactData?.currentCustomer?.emails, EMAIL_TYPES.RECEIPT_COPY);
    const { userProfile } = useGetCurrentUserProfile();
    const isSuperuser = userProfile?.roles?.some(role => role.displayName === 'Superuser') ?? false;

    // TODO: do we need to check for more than 49 tasks?
    const { data: customerTasksData, loading: customerTasksLoading } = useGetCustomer<CustomerTasksResponse>(
        GET_CUSTOMER_TASKS_QUERY,
        { first: null, after: null, before: null, last: 49 },
        { fetchPolicy: 'network-only' }
    );
    const hasPendingDeleteTask = customerTasksData?.currentCustomer?.tasks?.nodes?.some(
        task => task.closedAt === null && task.description?.includes('Kund har begärt att få sitt konto raderat')
    ) ?? false;

    let disabledTooltipText = '';
    if (hasPendingDeleteTask) {
        //console.log('Customer has pending delete account task')
        disabledTooltipText = 'Du har redan en pågående begäran om att ta bort ditt konto.'
    } else if (!isSuperuser) {
        disabledTooltipText = 'Endast administratörer kan ta bort kontot.'
    }

    if (hasPendingDeleteTask) {

    }

    return (
        <div className={classNames(
            'profile-settings-delete-account',
            'profilesettingsdeleteaccount_component',
            'white-pale-section',
            'shadow-one',
            'with-header',
            wrapperClasses
        )}>
            <div className="header">
                <h2 className="body-text">
                    <ManageAccountIcon width={26} height={26} />
                    Avsluta konto
                    <Tooltip text="Ta bort ditt konto och avsluta alla tjänster." position="top-end">
                        <InfoIconOutlined width="26" height="26" />
                    </Tooltip>
                </h2>
            </div>

            <div className="content">
                <h5 className="body-text">
                    Vill du ta bort ditt konto?
                </h5>
                {(hasP || hasK || hasBankCards || hasAppAgreement) ?
                    (
                        <>
                            <p>Vill du avsluta en enskild tjänst, kan du antingen spärra dina kort eller höra av dig till vår <Link href="/kontakt">kundservice</Link>.</p>
                            <p>Genom att ta bort ditt konto så avslutar du följande tjänster:</p>
                        </>

                    ) : (
                        <p>För att ta bort ditt konto och dina uppgifter från Qstar gå vidare för att bekräfta borttagningen genom att klicka på knappen nedan.</p>
                    )}
                <ul>
                    {hasP && <li>Smartkort</li>}
                    {hasK && <li>{isCompany ? 'Företagskort' : 'Tankkort'}</li>}
                    {(hasP || hasK) && hasReceiptEmails && <li>Kvittokopior</li>}
                    {hasAppAgreement && <li>Appkonto</li>}
                </ul>
                <RightsWrapper
                    disableButtonText={'Vidare'}
                    notAButton={false}
                    overrideTooltipText={hasPendingDeleteTask ? 'Du har redan en pågående begäran om att ta bort ditt konto.' : ''}
                    onlySuperUser={true}
                    disableButtonClasses='body-text disabled-button'
                    forceDisabled={hasPendingDeleteTask}
                    toolTipPosition='top-start'
                >
                    <Link href="/avsluta-konto" className="delete-account-link dashboard-button no-margin">
                        Vidare
                    </Link>
                </RightsWrapper>
            </div>
        </div>
    )
}

export default ProfileDeleteAccount;